<template>
<div class="resources-tab">
	<button class="button pink">PDF: Lorem IPSUM DOLOR SIT amet</button>
	<button class="button primary">Doc: Dolor Sit Amet</button>
	<button class="button green">XLS: Lorem Ipsum</button>
</div>
</template>

<script>
export default {

}
</script>

<style lang="scss">
.resources-tab {
	display: inline-table;

	.button {
		font-weight: 200;
		width: auto;
		font-size: 10px;
		padding: 7px 11px;
		float: left;
		margin: 0px 9px 0px 0px;

		&:first-child {
			margin-bottom: 5px;
		}
	}
}
</style>
